export default [
  {
    key: 'agent_code',
    value: '',
    label: 'agentCode',
    rules: {
      requiredWithFormat: true,
      minmax: { min: 6, max: 30 },
      adminID: true,
    },
    name: 'agentCode',
    as: 'input',
  },
  {
    key: 'company',
    value: '',
    label: 'company',
    rules: { required: true, scope: { min: 1, max: 30 } },
    name: 'company',
    as: 'input',
  },
  {
    key: 'admin_name',
    value: '',
    label: 'administratorId',
    rules: {
      requiredWithFormat: true,
      minmax: { min: 6, max: 30 },
      adminID: true,
    },
    name: 'administratorId',
    as: 'input',
  },
  {
    key: 'admin_display_name',
    value: '',
    label: 'adminDisplayName',
    rules: { required: true, max: 100 },
    name: 'adminDisplayName',
    as: 'input',
  },
  {
    key: 'email',
    value: '',
    label: 'email',
    rules: { requiredWithFormat: true, email: true },
    name: 'email',
    as: 'input',
  },
  {
    key: 'password',
    value: '',
    label: 'password',
    rules: {
      password: true,
      confirmed: 'passwordConfirm',
      required: true,
    },
    name: 'password',
    as: 'input',
    type: 'password',
  },
  {
    key: 'password_2',
    value: '',
    label: 'passwordConfirm',
    rules: {
      confirmed: 'password',
      password: true,
      required: true,
    },
    name: 'passwordConfirm',
    as: 'input',
    type: 'password',
  },
  {
    key: 'privacy_policy_URL',
    value: '',
    label: 'privacyPolicyURL',
    rules: { required: true, max: 2000 },
    name: 'privacyPolicyURL',
    as: 'input',
  },
  {
    key: 'welcome_message',
    value: '',
    label: 'welcomeMessage',
    rules: { required: true, max: 1000 },
    name: 'welcomeMessage',
    as: 'area',
  },
]
